import { useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";

import classes from "./profile.module.scss";

import api from "@/services/api.service";
import Fetching from "@/components/Fetching/Fetching";
import { useSelector } from "react-redux";

const ProfileHead = ({ data, setData }) => {
	const refFile = useRef(null);

	const { customer } = useSelector((state) => state.auth.user);

	const [loadingPhoto, setLoadingPhoto] = useState(false);

	const handlePhoto = (e) => {
		setLoadingPhoto(true);

		const body = new FormData();
		body.append("File", e.target.files[0]);

		api.post("/client/profile/photo", body).then((response) => {
			setData({ ...response.profile });
			setLoadingPhoto(false);

			refFile.current.value = "";
		});
	};

	return (
		<>
			<Col md={3} xs={6} className={classes.div_image}>
				{loadingPhoto ? (
					<Fetching topMargin={"1em"} />
				) : (
					<img
						src={data.photo ? data.photo : "/profile.png"}
						alt="Profile"
						className={classes.icon}
						onClick={(_e) => refFile.current && refFile.current.click()}
					/>
				)}

				<input style={{ display: "none" }} type="file" accept="image/*" ref={refFile} onChange={(e) => handlePhoto(e)} />
			</Col>
			<Col md={9} xs={6} className={classes.div_name}>
				<div className={classes.div_detail}>
					<h4 className={classes.user_name}>{data && data.name}</h4>
				</div>
				<div className={classes.div_detail}>
					<span className={classes.company_name}>{data && data.customer_name}</span>
				</div>

				<Row className={classes.div_list}>
					<Col md={4} xs={12}>
						<div className={classes.col_list}>
							<span className={classes.list_title}>Roles</span>

							{data &&
								data.roles &&
								data.roles.map((rol, j) => {
									return (
										<div className={classes.list_item} key={j}>
											{rol.name}
										</div>
									);
								})}
						</div>
					</Col>

					{!!customer.use_estates_parents && (
						<Col md={4} xs={12}>
							<div className={classes.col_list}>
								<span className={classes.list_title}>
									{customer.customer_screens.find((cs) => cs.screen_id === 38)
										? customer.customer_screens.find((cs) => cs.screen_id === 38).name
										: "Grupos Campos"}
								</span>
								{data &&
									data.estates_parents &&
									data.estates_parents.map((estate_parent, j) => {
										return (
											<div className={classes.list_item} key={j}>
												{estate_parent.name}
											</div>
										);
									})}
							</div>
						</Col>
					)}

					<Col md={4} xs={12}>
						<div className={classes.col_list}>
							<span className={classes.list_title}>
								{customer.customer_screens.find((cs) => cs.screen_id === 51)
									? customer.customer_screens.find((cs) => cs.screen_id === 51).name
									: "Campos"}
							</span>
							{data &&
								data.estates &&
								data.estates.map((estate, j) => {
									return (
										<div className={classes.list_item} key={j}>
											{estate.name}
										</div>
									);
								})}
						</div>
					</Col>
				</Row>
			</Col>
		</>
	);
};

export default ProfileHead;
